import React from 'react';
// import Custom loader library
import ContentLoader from 'react-content-loader';

//  define custom loader svg
const Loader = props => (
    <ContentLoader
        height={props.height}
        primaryColor={props.pcolor ? props.pcolor : ' #f0f0f0'}
        secondaryColor={props.sec_color ? props.sec_color : '#d6dcd6'}
    >
        {/* svg only */}
        <rect
            x={props.xOffset ? props.width : '0'}
            y="0"
            rx="3"
            ry="3"
            width={props.width}
            height={props.height}
        />
    </ContentLoader>
);

//  define custom loader svg
export default Loader
export const CircularLoader = props => (
    <ContentLoader
        height="100"
        primaryColor={props.pcolor ? props.pcolor : ' #f0f0f0'}
        secondaryColor={props.sec_color ? props.sec_color : '#d6dcd6'}
    >
        <circle cx="200" cy="50" r={props.radius || 30} />
    </ContentLoader>
);
